module.exports = {
  email: "anubhav.kumar27@gmail.com",

  socialMedia: [
    {
      name: `GitHub`,
      url: `https://github.com/keiken-shin`,
    },
    {
      name: `Linkedin`,
      url: `https://www.linkedin.com/in/keiken-shin/`,
    },
    {
      name: `Dribbble`,
      url: `https://dribbble.com/keiken_shin`,
    },
    {
      name: `Twitter`,
      url: `https://twitter.com/keiken_shin`,
    },
    {
      name: `Codepen`,
      url: `https://codepen.io/keiken-shin`,
    },
  ],

  navLinks: [
    {
      name: `Home`,
      url: `/`,
      icon: `HomeIcon`,
    },
    {
      name: `About`,
      url: `/#about`,
      icon: `AboutIcon`,
    },
    {
      name: `Experience`,
      url: `/#jobs`,
      icon: `WorkIcon`,
    },
    {
      name: `Projects`,
      url: `/#projects`,
      icon: `ProjectIcon`,
    },
  ],

  colors: {
    neutralLight: `#f7f7f7`,
    barleyWhite: `#F9F1BA`,
    amaranth: `#DC2249`,
    amaranthDark: `#BD1D3E`,
    bitterSweet: `#FF6E6E`,
    deepSky: `#00ADFF`,
    neonPurple: `#6937FF`,
    violet: `#221E41`,
    cosmic: `#7A4865`,
    springWood: `#E5DCD3`,
    suvaGrey: `#8A8785`,
    neutralDark: `#161718`,
    burntSiena: `#EE7C51`,
    lightDeepSky: `rgba(0,173,255,0.15)`,
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    mobile: true,
    reset: false,
    useDelay: "always",
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
}
